exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".devices-list-component[data-v-3b1d2c4b] {\n  width: 100%;\n  margin-top: 1rem;\n}", ""]);

// exports
